var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { B64File } from 'common/classes/B64File.class';
import { MembreService } from 'membre/store/service';
/**
 * Permet aux utilisateur d'avoir plusieurs photos de profil
 */
export class MembreImageProfil {
    /**
     * Constructeur de l'objet MembreImageProfil
     * @param row array contenant les données de l'objet
     */
    constructor(row) {
        var _a, _b, _c, _d;
        if (row) {
            this.idMembreImageProfil = (_a = row.idMembreImageProfil) !== null && _a !== void 0 ? _a : null;
            this.idMembre = (_b = row.idMembre) !== null && _b !== void 0 ? _b : null;
            this.dateEnregistrement = (_c = row.dateEnregistrement) !== null && _c !== void 0 ? _c : null;
            this.actif = (_d = row.actif) !== null && _d !== void 0 ? _d : 0;
            this.profilePicture = row.profilePicture ? new B64File(row.profilePicture) : null;
        }
    }
    /**
     * Sauvegarde une nouvelle image de profil
     * @param imageProfil La photo de profil à enregistrer
     * @return True si l'image de profil a été enregistrée avec succès, false sinon
     */
    static save(imageProfil) {
        return __awaiter(this, void 0, void 0, function* () {
            return MembreService.saveAvatar(imageProfil);
        });
    }
    /**
     * Récupération d'une image de profil en BDD
     * @return MembreImageProfil
     */
    static find( /* id: number */) {
        // TODO
    }
    /**
     * Utilisée pour renvoyer les informations au back.
     */
    toRaw() {
        return {
            idMembreImageProfil: this.idMembreImageProfil,
            idMembre: this.idMembre,
            dateEnregistrement: this.dateEnregistrement,
            actif: this.actif,
            profilePicture: this.profilePicture.toRaw(),
        };
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWVtYnJlSW1hZ2VQcm9maWwuY2xhc3MuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJNZW1icmVJbWFnZVByb2ZpbC5jbGFzcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSxPQUFPLEVBQUUsT0FBTyxFQUFFLE1BQU0sOEJBQThCLENBQUM7QUFDdkQsT0FBTyxFQUFFLGFBQWEsRUFBRSxNQUFNLHNCQUFzQixDQUFDO0FBSXJEOztHQUVHO0FBQ0gsTUFBTSxPQUFPLGlCQUFpQjtJQStCN0I7OztPQUdHO0lBQ0gsWUFBbUIsR0FBZ0M7O1FBQ2xELElBQUksR0FBRyxFQUFFO1lBQ1IsSUFBSSxDQUFDLG1CQUFtQixHQUFHLE1BQUEsR0FBRyxDQUFDLG1CQUFtQixtQ0FBSSxJQUFJLENBQUM7WUFDM0QsSUFBSSxDQUFDLFFBQVEsR0FBRyxNQUFBLEdBQUcsQ0FBQyxRQUFRLG1DQUFJLElBQUksQ0FBQztZQUNyQyxJQUFJLENBQUMsa0JBQWtCLEdBQUcsTUFBQSxHQUFHLENBQUMsa0JBQWtCLG1DQUFJLElBQUksQ0FBQztZQUN6RCxJQUFJLENBQUMsS0FBSyxHQUFHLE1BQUEsR0FBRyxDQUFDLEtBQUssbUNBQUksQ0FBQyxDQUFDO1lBQzVCLElBQUksQ0FBQyxjQUFjLEdBQUcsR0FBRyxDQUFDLGNBQWMsQ0FBQyxDQUFDLENBQUMsSUFBSSxPQUFPLENBQUMsR0FBRyxDQUFDLGNBQWMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUM7U0FDbEY7SUFDRixDQUFDO0lBRUQ7Ozs7T0FJRztJQUNJLE1BQU0sQ0FBTyxJQUFJLENBQUMsV0FBK0I7O1lBQ3ZELE9BQU8sYUFBYSxDQUFDLFVBQVUsQ0FBQyxXQUFXLENBQUMsQ0FBQztRQUM5QyxDQUFDO0tBQUE7SUFFRDs7O09BR0c7SUFDSSxNQUFNLENBQUMsSUFBSSxFQUFDLGdCQUFnQjtRQUNsQyxPQUFPO0lBQ1IsQ0FBQztJQUVEOztPQUVHO0lBQ0ksS0FBSztRQUNYLE9BQU87WUFDTixtQkFBbUIsRUFBRSxJQUFJLENBQUMsbUJBQW1CO1lBQzdDLFFBQVEsRUFBRSxJQUFJLENBQUMsUUFBUTtZQUN2QixrQkFBa0IsRUFBRSxJQUFJLENBQUMsa0JBQWtCO1lBQzNDLEtBQUssRUFBRSxJQUFJLENBQUMsS0FBSztZQUNqQixjQUFjLEVBQUUsSUFBSSxDQUFDLGNBQWMsQ0FBQyxLQUFLLEVBQUU7U0FDM0MsQ0FBQztJQUNILENBQUM7Q0FDRCJ9